import { render, staticRenderFns } from "./VehicleBlock.vue?vue&type=template&id=789bf6fd"
import script from "./VehicleBlock.vue?vue&type=script&lang=js"
export * from "./VehicleBlock.vue?vue&type=script&lang=js"
import style0 from "./VehicleBlock.vue?vue&type=style&index=0&id=789bf6fd&prod&scss=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports